export default __webpack_public_path__ + "static/media/002.520cfb5b.png";